export const ContentCard = ({ children }: { children: React.ReactNode }) => (
	<div className="flex h-full w-full max-w-[768px] flex-col rounded-lg lg:border xl:w-1/2 xl:max-w-[650px] xl:border-neutral-faded print:h-auto">
		{children}
	</div>
);
